export enum AppRoutesEnum {
    calendar = 'calendar',
    profile = 'profile',
    settings = 'settings',
    semaphore = 'semaphore',
    admin = 'admin-panel',
    checkIn = 'check-in',
    mobileApp = 'mobile-app',
    addEvent = 'add-event'
}
